import React from "react";
import GridDuck from "gridduck";
import {Button, Card, CardBody, CardHeader, Input, Toast} from "gd-react";
import cookie from "react-cookies";
import history from "./../../meta/history";
import moment from "moment";

class EnergyMasterTest extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            emailAddress: ''
        };
        this.onFormChange = this.onFormChange.bind(this);
        this.sendTestEmail = this.sendTestEmail.bind(this);
    }

    sendTestEmail() {
        const midnight = moment().startOf('day').format('YYYY-MM-DD HH:mm:ss');

        return GridDuck.createEnergyMasterTest({
            "site": "diversey",
            "siteId": "451b0547-9ba4-4e2b-9c99-1e67c5348ad5",
            "forecastedStart": midnight,
            "recipients": ["alex@gridduck.com"],
            "solarProduction": [
                -0.0328933597, -0.0098108007, -0.0116325058, -0.0013813144, 0.0008919574,
                0.0022505827, 0.4534163475, 4.766143322, 15.9431619644, 31.635925293, 49.909362793, 66.7070999146, 78.3679504395, 80.4561004639,
                81.9074554443, 74.9568862915, 58.8566207886, 41.3119277954, 23.9359607697,
                5.8649973869, 0.0547678173, -0.069780454, -0.0599387586, -0.0470739007
            ],
            "consumption": [
                38.7357292175, 40.0076789856, 37.4527168274, 43.0573158264, 42.7976417542,
                43.7636451721, 48.1744499207, 45.6491279602, 54.1116905212, 38.1151618958, 51.1132049561, 60.5320587158, 64.1186981201, 65.4392318726,
                75.1226425171, 71.3955764771, 65.090713501, 59.2046813965, 45.1095352173,
                47.4570617676, 56.2604217529, 55.8868865967, 58.2226142883, 53.1037025452
            ],
            "flexibleConsumption": [
                6.122859478, 5.8479156494, 5.6376810074, 5.5395498276, 5.8366150856,
                6.1205544472, 6.1130542755, 6.129263401, 6.4693965912, 8.1797332764, 7.9048113823, 7.270608902, 7.7470908165, 7.2798352242,
                6.4556903839, 5.8994574547, 6.1427822113, 6.1872243881, 6.179497242,
                6.2891898155, 5.8844623566, 5.8508467674, 6.0395979881, 5.6328287125
            ]
        })
    }

    onFormChange(val) {
        this.setState({emailAddress: val.target.value});
    }

    render() {
        return (
            <div className='page narrow Account not-flex grey'>

                <div className={'column top'}>
                    <div className={'detail-content'}>
                        <Card>
                            <CardHeader>Test Energy Master Forecast Email</CardHeader>
                            <CardBody><Input value={this.state.emailAddress} onChange={this.onFormChange}
                                             label={'Email address'}/>
                                <br/>
                                <Button additionalclasses={'sm'} color={'gd-green'} onClick={this.sendTestEmail}
                                        label={'Submit'}/>
                            </CardBody>
                        </Card>
                    </div>
                </div>
            </div>
        )
    }
}

export default EnergyMasterTest;
